<template>
  <div class="screen-vote" :class="{'filter-blur':activitymoadal==true}">
    <div class="tab-class">
      <!-- <button class="all" :class="tabIndex == 0?'active':''" @click="changeTab(0,-1)">全部</button>
      <button class="item-class" v-for="(item,index) in classList" :key="index" :class="tabIndex == (index+1)?'active':''" @click="changeTab(index+1,item.classID)" :id="'item_'+item.classID">{{item.classCode}}</button> -->
      <div  class="all" @click="chooseClass"><span class="all-choose">{{tabIndex == 0?'全部':classList[tabIndex-1].classname}}</span><span class="iconfont icon-sanjiao"></span></div>
      <div class="class-box" v-show="classModal">
        <div class="item-class" :class="tabIndex == 0?'active':''" @click="changeTab(0,-1)">全部</div>
        <div class="item-class" v-for="(item,index) in classList" :key="index" :class="tabIndex == (index+1)?'active':''" @click="changeTab(index+1,item.classID)" :id="'item_'+item.classID">{{item.classname}}</div>
      </div>
    </div>
    <div class="tab-content">
      <div class="content-item">
        <div class="class-title">
          {{tabIndex == 0?'全部班级':classList[tabIndex-1].classname}}
        </div>
        <div class="calss-detial">
          <div class="chart-pie">
                <div id="echartContainer" style="width:495px; height:410px"></div>
          </div>
          <div class="chart-choose" v-scrollBar>
            <div class="choose-item" v-for="(item,index) in options" :key="index">
              <div class="detial" :style="{'background': colors1[index],'width': getPercent(item.votedCount)+'%'}">
                <span class="option">{{String.fromCharCode('A'.charCodeAt(0) + index)}}</span>
                <span class="text">{{item.value}}</span>
                <span class="num">{{item.votedCount}}票</span>
              </div>
            </div>
            <div class="choose-item">
              <div class="detial">
                <span class="option"></span>
                <span class="text">未投</span>
                <span class="num">{{studentCount-votedCount}}人</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="img-modal" v-show="showImgModal" @click="closeImgModal">
      <div class="img">
          <img :src="imgUrl" alt="">
          <span class="iconfont icon-guanbi img-close"></span>
      </div>
    </div>
  </div>
</template>

<script>
var echarts = require('echarts')
import EventHandler from '../../common/js/EventHandler'
export default {
  name: 'vote',
  props:{activitymoadal:Boolean},
  data () {
    return {
      classList:[],
      options:[],
      voteDetial:[],
      colors: ['#FFEE51', '#FFAB00', '#F65E5E', '#bb63ca', '#4BA8F0', '#91F8E9', '#59D799', '#C1FE4E', '#516377', 
                        '#FCAEAE'],
      colors1:['rgba(255, 238, 81,0.5)','rgba(255, 171, 0,0.5)','rgba(246, 94, 94,0.5)','rgba(187, 99, 202,0.5)','rgba(75, 168, 240,0.5)','rgba(145, 248, 233,0.5)','rgba(89, 215, 153,0.5)'
      ,'rgba(193, 254, 78)','rgba(81, 99, 119,0.5)','rgba(252, 174, 174,0.5)'],
      tabIndex:0,
      voteId:0,
      userId:0,
      votedCount:0,
      classId:-1,
      imgUrl:'',
      showImgModal:false,
      classData:[],
      studentCount:0,
      votedCount:0,
      unVoted:0,//未投
      timer: null,  // 定时器名称 
      classModal:false,
    }
  },
  methods:{
    //轮训查询投票详情
    voteDetail:function(){
      var that = this;
      this.timer = setInterval(function() {
        that.votedCountApi()
      }, 2000)
    },
    votedCountApi:function(){
      var that = this;
      that.$http.get(that.baseURL1+'/voteV2/detail/'+that.voteId+'/'+that.userId+'/'+that.classId).then((res)=>{
          var data = res.data;
          var newDataList= [];
          that.classList= data.classes;
          that.options = data.options;
          that.imgUrl = data.vote.picture;
          that.studentCount = data.studentCount;
          that.votedCount = data.votedCount;
          var alreadyCount = 0;
          for(var i = 0; i < data.options.length; i++){
            alreadyCount += data.options[i].votedCount;
            if(data.options[i].votedCount>0){
              newDataList.push({
                name: String.fromCharCode('A'.charCodeAt(0) + i),
                value: data.options[i].votedCount,
                itemStyle:{
                  normal: {color: that.colors[i],borderColor:'#fff',borderWidth:'3'}
                }
            });
            }
          }
          if(newDataList.length == 0){
            newDataList.push({
              name:'',
              value:data.studentCount == 0?1:data.studentCount-alreadyCount,
              itemStyle:{
                    normal: {color: '#f1f3f7'},
                    emphasis: {color: '#f1f3f7'},
              }
            })
          }          
          that.classData = newDataList;
          that.voteDetial = data.vote;
          that.votedCount = data.votedCount;
          that.unVoted = data.studentCount-alreadyCount;
          //将title等传给父路由
          that.$emit('pushDetial',data.vote)
          that.drawPie()
          // if(data.vote.endDate){
          //   clearInterval(that.timer)
          //   that.timer = null;
          // }
      })
    },
    changeTab:function(index,classID){
      clearInterval(this.timer);   
      this.timer = null;
      this.tabIndex = index;
      this.classId = classID;
      this.classModal = false;
      this.votedCountApi();
      this.voteDetail();
    },
    getPercent:function(votedCount){
      if(votedCount == 0){
        return 0
      }else{
        return ((votedCount/this.studentCount).toFixed(2))*100
      }
    },
    drawPie:function(){
    // 基于准备好的dom，初始化echarts实例
    var myChart = echarts.init(document.getElementById('echartContainer'));
    // 绘制图表
    var classData = this.classData;
    // var colors = newColors;
    myChart.setOption({
    series : [
              {
                  name: '访问来源',
                  type: 'pie',
                  radius: '60%',
                  center: ['50%', '50%'],
                  data:classData,
                  legendHoverLink:false,
                  label:{
                    fontSize:24,
                    fontWeight:'bold',
                    color:'#444',
                    formatter:function(data){ return data.name?data.name+':'+data.percent.toFixed(1)+"%":'';} 
                  },
                  labelLine:{
                    length:15,
                    length2:5
                  }
              }
          ]
      })
    },
    largePic:function(){
      this.showImgModal = true;
    },
    closeImgModal:function(){
      this.showImgModal = false;
    },
    chooseClass:function(){
      this.classModal = !this.classModal;
    },
    changeClass:function(param){
      if(param == -1){
        this.changeTab(0,-1)
      }else{
        $('#item_'+param).click()
      }
    },
    votePicOperation:function(param){
      if(param == 0){
        this.closeImgModal()
      }else{
        this.$emit('openVotePic')
      }
    }
  },
  created:function(){
    EventHandler.bindEvent('changeClass',this.changeClass)
    EventHandler.bindEvent('votePicOperation',this.votePicOperation)
    this.userId = this.common.getCookie('userId')
    this.voteId = this.common.getCookie('activityId')
    this.votedCountApi()
    this.voteDetail()
  },
  computed:{

  },
  watch:{
  },
  mounted:function(){
    
  },
  beforeDestroy() {
    clearInterval(this.timer);        
    this.timer = null;
 }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'vote.scss'
</style>



// WEBPACK FOOTER //
// src/components/vote/vote.vue